import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

const tripSelected = ({
    batchId,
    count,
    position,
    price,
    tripId,
}) => {
    const property = {
        batch_id: batchId,
        position: position,
        price: price,
        results_count: count,
        search_sort_name: 'recommended',
        trip_id: tripId,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select_result',
        category: 'react_search',
        label: 'travel_options',
        property,
    });

    amplitude.track('travel_options selected_result', property);
};

export default {
    tripSelected,
};
